import { useEffect } from "react";
import { resolvePageMetadata, type TinaSeoFields } from "./seo-data";
import { updateDocumentMetadata } from "./seo-head";

interface PageSeoProps {
  pathname: string;
  seo?: TinaSeoFields | null;
}

export const PageSeo = ({ pathname, seo }: PageSeoProps) => {
  useEffect(() => {
    updateDocumentMetadata(resolvePageMetadata(pathname, seo));
  }, [pathname, seo]);

  return null;
};
